import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ShipWiseBatchRecordsComponent from './records/ShipWiseBatchRecordsComponent'
import ShipWiseBatchConfigurationComponent from './batch/ShipWiseBatchConfigurationComponent'
import { Accordion, ButtonGroup, ToggleButton } from 'react-bootstrap'
import { DateTime } from 'luxon'
import HamburgerSvg from '../../common/components/svg/HamburgerSvg'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import '../styles/shipwise.css'
import '../../react-tabs.css'
import EditPencilSvg from '../../common/components/svg/EditPencilSvg'
import ClockSvg from '../../common/components/svg/ClockSvg'
import ShipWiseBatchRunsComponent from './batch-runs/ShipWiseBatchRunsComponent'
import ShipWiseOrderShippedComponent from './order-shipped/ShipWiseOrderShippedComponent'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck } from '@fortawesome/free-solid-svg-icons'
import DeliveryTruckSvg from '../../common/components/svg/DeliveryTruckSvg'

const PAGE_TABS = {
  Orders: {
    Title: 'Orders',
    Key: 'orders'
  },
  Configuration: {
    Title: 'Batch Configuration',
    Key: 'batchconfig'
  }
}

const ShipWiseComponent = () => {
  const view = useMemo(() => {
    return (
      <div className='shipwise-main'>
        <div id="top"></div>
        <div className='shipwise-card'>
          <table className='beacon-table'>
            <tbody>
              <tr>
                <td><span className='beacon-header'>SHIPWISE</span></td>
              </tr>
              <tr>
                <td><span className='beacon-label'>Manage orders created in ShipWise, manage batch configurations, or see batch runs here.</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <Tabs>
          <TabList>
            <Tab key='orderTab'>
              <span className='shipwise-header'>
                <HamburgerSvg height={25}/> ORDERS
              </span>
            </Tab>
            <Tab key='configTab'>
              <span className='shipwise-header'>
                <EditPencilSvg height={25}/> CONFIGURATION
              </span>
            </Tab>
            <Tab key='runsTab'>
              <span className='shipwise-header'>
                <ClockSvg height={25}/> BATCH RUNS
              </span>
            </Tab>
            <Tab key='orderShippedTab'>
              <span className='shipwise-header'>
                <DeliveryTruckSvg height={25} /> ORDER SHIPPED
              </span>
            </Tab>
          </TabList>
          <TabPanel key='orderTabPanel'>
            <ShipWiseBatchRecordsComponent />
          </TabPanel>

          <TabPanel key='configTabPanel'>
            <ShipWiseBatchConfigurationComponent />
          </TabPanel>

          <TabPanel key='runsTabPanel'>
            <ShipWiseBatchRunsComponent />
          </TabPanel>

          <TabPanel key='orderShippedTabPanel'>
            <ShipWiseOrderShippedComponent />
          </TabPanel>
        </Tabs>
      </div>
    )
  }, [])

  return view
}

export default ShipWiseComponent
